module.exports = __webpack_public_path__ + "static/media/error.a7820e98.svg";